import type { BreadcrumbConfig } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Contacts } from "@/src/gql/graphql";

// ============================================================================
// CONTACT DETAIL BREADCRUMBS CONFIGURATION
// ============================================================================

export const contactDetailBreadcrumbs: BreadcrumbConfig = {
  show: true,
  items: [
    { label: "Contacts", href: "/contacts" },
    {
      label: "Contact Details",
      href: (contact: Contacts) => `/contacts/${contact.id}`,
      current: true,
    },
  ],
};
